// extracted by mini-css-extract-plugin
export default {"noLabel_box":"BatchEditModal_noLabel_box__Qi5RB","dash":"BatchEditModal_dash__oE3Ql","info_box":"BatchEditModal_info_box__U8ifn","icon_sty":"BatchEditModal_icon_sty__5q9O+"};